import type { QueryClient } from "@tanstack/react-query";
import { PrivatesAppointmentsApi } from "@/openapi/generated";
import type { AppointmentScrollQuery } from "@/openapi/generated/models";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchAppointmentsGet(
  queryClient: QueryClient,
  appointmentScrollQuery?: AppointmentScrollQuery,
  page: number = 1,
  pageSize: number = 100,
  lastSelectedId?: number | null,
  active?: boolean,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching appointments");
  }

  const service = createAuthenticatedApi(PrivatesAppointmentsApi, accessToken);

  const query = appointmentScrollQuery || ({} as AppointmentScrollQuery);

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.Appointments,
      query,
      page,
      pageSize,
      lastSelectedId,
      active,
    ],
    queryFn: () =>
      service.apiAppointmentsScrollPost({
        appointmentScrollQuery: query,
        page,
        pageSize,
        lastSelectedId: lastSelectedId ?? undefined,
        active,
      }),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return queryClient;
}

